module.exports = __webpack_public_path__ + "img/kr-product-final-card3-rightBottom-img.fee7466.png";